import numberUtils from './numberUtils';

const { cleanPhoneNumber } = numberUtils;

type contactMethodsType = {
  emails: Array<{ value: string } | string>;
  phones: Array<{ value: string } | string>;
};

const listingClaimUtils = {
  isEmailInContactMethods: (contactMethods: contactMethodsType, listingEmail: string) =>
    contactMethods.emails.some((contact) => {
      if (typeof contact === 'string') {
        return contact === listingEmail;
      } else {
        return contact.value === listingEmail;
      }
    }),
  isPhoneInContactMethods: (contactMethods: contactMethodsType, listingPhone: string) =>
    contactMethods.phones
      .map((phoneNumber) => {
        if (typeof phoneNumber === 'string') {
          return cleanPhoneNumber(phoneNumber);
        } else {
          return cleanPhoneNumber(phoneNumber.value);
        }
      })
      .includes(cleanPhoneNumber(listingPhone)),
  getContactType: (contact: { value: string }) => (isNaN(parseInt(contact.value, 10)) ? 'email' : 'phone'),
  getVerifiedContacts: (combinedContactMethods: Array<{ isVerified: boolean }>) =>
    combinedContactMethods.some((contactMethod) => contactMethod.isVerified),
  combineContactMethods: ({
    emails,
    phones,
  }: {
    emails: Array<{ isVerified: boolean }>;
    phones: Array<{ isVerified: boolean }>;
  }) => [...emails, ...phones].sort((a, b) => (a.isVerified ? -1 : 1) - (b.isVerified ? -1 : 1)),
  getConversionRate: ({ failed, succeeded, total }: { [key: string]: number }) => ((failed + succeeded) / total) * 100,
};

export default listingClaimUtils;
